// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-31gi0";
var _3 = "header__text-3UJyB";
var _4 = "flight-2xI8-";
var _5 = "flight__direction-Qe01c";
var _6 = "passenger-1ABjY";
var _7 = "notification-Qb-7M";
var _8 = "icon-1hrls";
var _9 = "notification__title-CnVE5";
var _a = "text-1LoIl";
var _b = "newSearch-EqQn7";
var _c = "continueButton-hJPZo";
export { _1 as "__esModule", _2 as "container", _3 as "header__text", _4 as "flight", _5 as "flight__direction", _6 as "passenger", _7 as "notification", _8 as "icon", _9 as "notification__title", _a as "text", _b as "newSearch", _c as "continueButton" }
export default { "__esModule": _1, "container": _2, "header__text": _3, "flight": _4, "flight__direction": _5, "passenger": _6, "notification": _7, "icon": _8, "notification__title": _9, "text": _a, "newSearch": _b, "continueButton": _c }
